import React, {Component} from 'react';
import { Switch, Route, Redirect } from 'react-router-dom'
import {Row, Col, Card} from 'reactstrap';
import ProjectsList from '../../components/Projects/ProjectsList';
import Elements from '../../components/Projects/Elements';
import InspectionCategoryList from '../../components/InspectionCategory/InspectionCategoryList';
import LogsList from '../../components/Logs/LogsList';

export default class Projects extends Component {

  render() {
    return (
      <div className="animated fadeIn">
        <Row>
          <Col md="12">
            <Card>
              <Switch>
                <Route exact path="/projects" component={ProjectsList}/>
                <Route exact path="/projects/:tab(welds|ndt|elements|details|config|grouping-welds)/:id" component={Elements}/>
                <Route exact path="/projects/:id/inspection-category" component={InspectionCategoryList}/>
                <Route exact path="/projects/welds/logs/:id" component={LogsList}/>
                <Route exact path="/projects/:id" render={({match}) => <Redirect to={`/projects/welds/${match.params.id}`} />} />
              </Switch>
            </Card>
          </Col>
        </Row>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/Projects/Projects.js